export const Paths = Object.freeze({
  employeesAmount: '/',
  currentlyMedical: '/current-insurance',
  planningPurchasing: '/purchase-timeframe',
  renewingCoverage: '/renewing-coverage',
  newHealth: '/purchase-reason',
  currentCarrier: '/current-carrier',
  switchingCoverage: '/changing-reason',
  totalAmount: '/employer-contribution',
  totalAmountDependent: '/dependent-contribution',
  recommendedPlans: '/plans',
  finalQuoteDetails: '/final-quote-details',
  employees: '/employees',
  finalQuote: '/final-quote/save',
  congratulations: '/final-quote',
  companyCensus: '/company-census',
  enrollment: '/enrollment',
  onboarding: '/onboarding',
  publicProviders: 'https://directories.anglehealth.com/care/doctors',
  publicFacilities: 'https://directories.anglehealth.com/facilities',
  yourPlans: '/your-plans',
  download: '/download',
  haveBroker: '/have-broker',
  avgAge: '/avg-age',
  zipCode: '/zip-code'
})
